export default __webpack_public_path__ + "static/media/Terms and Conditions.9a928bb7.pdf";